import { TableUIProvider } from "../../contexts/TableUIContext";
import PurchasedCourses from "./PurchasedCourses";

export default function PurchasedCoursesWrapper() {
    return (
        <TableUIProvider>
            <PurchasedCourses />
        </TableUIProvider>
    );
}

